<div class="contact-hospital">
  <div class="contact-hospital__icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" width="26" height="26">
      <path
        d="M6.6 10.8a15.9 15.9 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.4 11.4 0 0 0 3.6.58 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11.4 11.4 0 0 0 .58 3.6 1 1 0 0 1-.25 1l-2.23 2.2z" />
    </svg>
  </div>

  <p class="contact-hospital__message">
    {{ message | translate }}
  </p>

  <a href="#" class="contact-hospital__link" (click)="onRequestCall($event)">
    {{ linkLabel | translate }}
  </a>
</div>
